import { useRef } from 'react';
import generateId from './generateId';

var useId = function useId(customId) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rand';
  var idRef = useRef(customId || null);

  if (idRef.current === null) {
    idRef.current = generateId(prefix);
  }

  return idRef.current;
};

export default useId;